var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.375 36C66.375 42.0076 64.5936 47.8803 61.2559 52.8754C57.9183 57.8706 53.1743 61.7638 47.624 64.0628C42.0737 66.3619 35.9663 66.9634 30.0741 65.7914C24.182 64.6193 18.7697 61.7264 14.5216 57.4784C10.2736 53.2304 7.38069 47.818 6.20866 41.9259C5.03663 36.0337 5.63816 29.9263 7.93717 24.376C10.2362 18.8257 14.1294 14.0818 19.1246 10.7441C24.1197 7.40646 29.9924 5.625 36 5.625C44.0532 5.63393 51.774 8.83702 57.4685 14.5315C63.163 20.226 66.3661 27.9468 66.375 36ZM59.625 36C59.625 31.3274 58.2394 26.7598 55.6435 22.8747C53.0475 18.9895 49.3578 15.9615 45.0409 14.1733C40.724 12.3852 35.9738 11.9174 31.391 12.8289C26.8082 13.7405 22.5986 15.9906 19.2946 19.2946C15.9906 22.5986 13.7405 26.8082 12.829 31.391C11.9174 35.9738 12.3852 40.724 14.1734 45.0409C15.9615 49.3578 18.9896 53.0475 22.8747 55.6435C26.7598 58.2394 31.3274 59.625 36 59.625C42.2637 59.6183 48.2689 57.1271 52.698 52.698C57.1271 48.2689 59.6183 42.2637 59.625 36Z",
    fill: "#f40c0c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6378 22.3622L22.3622 49.6378",
    stroke: "#f40c0c",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3622 22.3622L49.6378 49.6378",
    stroke: "#f40c0c",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.332145b80e8e9a936f1794df9063b20a.svg";
export { ForwardRef as ReactComponent };